<template>
   <div>
     <v-stepper v-model="e6" vertical style="border:0;box-shadow:none;">
       <v-stepper-step

               step="1"
       >
         In your browser, while connected to the router's network, navigate to your router admin console
       </v-stepper-step>

       <v-stepper-content step="10">
         In most cases it will be on of the following:
         <ul>
           <li>http://192.168.1.1</li>
           <li>http://192.168.0.1</li>
           <li>http://192.168.2.1</li>
           <li>http://10.0.0.1</li>
         </ul>

       </v-stepper-content>


       <v-stepper-step step="2"
       >
         Sign in to the router's console.
       </v-stepper-step>

       <v-stepper-content step="10">
         popular default credentials are

         username: admin
         password: admin

         username: Admin
         password: admin

         username: home
         password: 12345678

       </v-stepper-content>



       <v-stepper-step step="3" >
         Look for the section that allows you to set the DNS
       </v-stepper-step>

       <v-stepper-content step="10">
         In some cases it might be found under, "Network settings" or "Advanced settings" then "DNS"
       </v-stepper-content>

       <v-stepper-step step="4" >
         Remove any address that already exist (Remember to keep it in case you want to revert the change)
       </v-stepper-step>

       <v-stepper-content step="10">



       </v-stepper-content>

       <v-stepper-step step="5" >
         Set GameEnable DNS IPs
       </v-stepper-step>

       <v-stepper-content step="10">
         <dns-ip-list></dns-ip-list>
       </v-stepper-content>

       <v-stepper-step step="6" >
         Save and Exist
       </v-stepper-step>

       <v-stepper-content step="10">

       </v-stepper-content>

     </v-stepper>


   </div>
</template>

<style scoped>

  >>> .v-stepper__label {
    color: rgba(0, 0, 0, 0.87)!important;
  }

</style>

<script>


  import dnsIpList from '../../../../components/dnsIpsList'
  // import i18n from '@/i18n';
  // import Page from '../mixins/page'


  export default {
    title: "Setup GameEnable's DNS for generic (any) router",
    name: 'set-router-dns/generic',
    data: ()=>({
      e6:10
    }),
    components: {

      dnsIpList

    },
  };
</script>
